<template>
  <div>
    <ModalAdicionarProcedimento
        v-if="modalNovoProcedimento"
        v-model="modalNovoProcedimento"
        :dente="dente"
        :atendimentoId="atendimentoId"
        @modalDenteSelecionadoAcaoFechar="fecharModalProcedimento"
        @procedimentoInserido="notificarProcedimentoInserido"
    />
    <ModalEditarProcedimento
        v-if="modalEditarProcedimento"
        v-model="modalEditarProcedimento"
        :dente="dente"
        :atendimentoId="atendimentoId"
        :procedimento="procedimentoSelecionado"
        @modalDenteSelecionadoAcaoFechar="fecharModalEditarProcedimento"
        @procedimentoAtualizado="notificarProcedimentoAtualizado"
    />
    <div v-if="dente" class="container-historico-dente">
      <div class="container-foto-dente-selecionado">
        <odontograma-dente :imagem="dente.foto" :possui-procedimentos="false"/>
      </div>
      <div class="container-informacoes-dente">
        <span>{{ dente.nome }} ({{ dente.numero }})</span>
        <div class="mt-1">
          <div class="detalhes-procedimentos-item">
            <v-icon small class="primary--text" v-if="dente.foiExtraido">fas fa-check</v-icon>
            <v-icon small class="error--text" v-if="!dente.foiExtraido">fa fa-times</v-icon>
            <label class="ml-1">Extraído</label>
          </div>
          <div class="detalhes-procedimentos-item">
            <v-icon small class="primary--text" v-if="dente.possuiCanal">fas fa-check</v-icon>
            <v-icon small class="error--text" v-if="!dente.possuiCanal">fa fa-times</v-icon>
            <label class="ml-1">Canal</label>
          </div>
          <div class="detalhes-procedimentos-item">
            <v-icon small class="primary--text" v-if="dente.possuiRestauracao">fas fa-check</v-icon>
            <v-icon small class="error--text" v-if="!dente.possuiRestauracao">fa fa-times</v-icon>
            <label class="ml-1">Restaurado</label>
          </div>
        </div>
      </div>
      <div class="container-btn-iniciar-procedimento">
        <div v-if="permiteEditarAtendimento">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" block depressed color="primary" @click="abrirModalNovoProcedimento">
                <v-icon>mdi-tooth</v-icon>
              </v-btn>
            </template>
            Iniciar novo procedimento
          </v-tooltip>
        </div>
        <div v-if="!permiteEditarAtendimento">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" block depressed class="btn-disabled">
                <v-icon color="grey">mdi-tooth</v-icon>
              </v-btn>
            </template>
            Não é possível adicionar um procedimento, selecione um atendimento válido!
          </v-tooltip>
        </div>
      </div>
    </div>
    <div :class="{'historico-dente-selecionado': dente}">
      <div class="label-primary-com-borda mt-1" v-if="atendimentoId"><label>Histórico de procedimentos do
        atendimento</label></div>
      <div class="label-primary-com-borda mt-1" v-else><label>Histórico de procedimentos</label></div>
      <OdontogramaProcedimentoTabela
          :itens="historicoList"
          :paginas="paginas"
          :paginacao="$store.state.atendimento.resultadoBuscaTodosProcedimentos.paginacao"
          :denteSelecionado="dente"
          :permiteEditarAtendimento="permiteEditarAtendimento"
          @paginar="tratarEventoPaginar"
          @editarProcedimento="abrirModalEditarProcedimento"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapMutations} from 'vuex'
import {actionTypes, mutationTypes} from '@/core/constants'
import OdontogramaProcedimentoTabela
from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaProcedimentoTabela.vue'
import OdontogramaDente from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaDente.vue'
import ModalAdicionarProcedimento
from '@/views/pages/cadastros/paciente/comum/odontograma/ModalAdicionarProcedimento.vue'
import ModalEditarProcedimento from '@/views/pages/cadastros/paciente/comum/odontograma/ModalEditarProcedimento.vue'

export default {
    name: 'OdontogramaMenuLateralDireito',
    components: {
        ModalEditarProcedimento,
        ModalAdicionarProcedimento,
        OdontogramaDente,
        OdontogramaProcedimentoTabela
    },
    props: {
        dente: Object,
        atendimentoId: Number,
        permiteEditarAtendimento: Boolean
    },
    data() {
        return {
            idPaciente: null,
            historicoList: [],
            paginas: 0,
            totalItens: 0,
            filtrosInterno: this.getFiltros(),
            modalNovoProcedimento: false,
            modalEditarProcedimento: false,
            procedimentoSelecionado: null,
        }
    },
    watch: {
        atendimentoId: {
            async handler() {
                await this.tratarEventoBuscaSimples()
            }
        },
        'dente.id': {
            async handler() {
                await this.tratarEventoBuscaSimples()
            }
        }
    },
    async mounted() {
        this.setarIdPaciente()
        await this.tratarEventoBuscaSimples()
    },
    methods: {
        ...mapMutations([
            mutationTypes.ATENDIMENTO.PROCEDIMENTO.SET_FILTROS_BUSCA_TODOS_PROCEDIMENTOS,
            mutationTypes.ATENDIMENTO.PROCEDIMENTO.SET_PAGINACAO_BUSCA_TODOS_PROCEDIMENTOS,
            mutationTypes.ATENDIMENTO.PROCEDIMENTO.RESETA_PAGE,
        ]),
        setarIdPaciente() {
            if (this.$route.params.id) {
                this.idPaciente = this.$route.params.id
            }
        },
        async tratarEventoBuscaSimples() {
            this.resetaPage()
            this.filtrosInterno.pacienteId.value = this.idPaciente
            this.filtrosInterno.atendimentoId.value = this.atendimentoId
            this.filtrosInterno.denteId.value = this.dente ? this.dente.id : null
            await this.buscar()
        },
        async buscar() {
            this.setFiltrosBuscaTodosProcedimentos(this.getFiltrosInterno())
            await this.buscarHistoricoProcedimentos()
        },
        async buscarHistoricoProcedimentos() {
            this.setMensagemLoading('Buscando histórico de procedimentos...')
            const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.BUSCAR_HISTORICO_PROCEDIMENTO)
            if (resposta) {
                this.historicoList = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
            }
        },
        getFiltros() {
            return _.cloneDeep(this.$store.state.atendimento.resultadoBuscaTodosProcedimentos.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        tratarEventoPaginar(paginacao) {
            this.setPaginacaoBuscaTodosProcedimentos(paginacao)
            this.buscar()
        },
        abrirModalNovoProcedimento() {
            if (!this.atendimentoId) {
                this.mostrarNotificacaoErro('Selecione um atendimento para incluir o procedimento!')
                return
            }
            this.modalNovoProcedimento = true
        },
        fecharModalProcedimento() {
            this.modalNovoProcedimento = false
        },
        fecharModalEditarProcedimento() {
            this.modalEditarProcedimento = false
        },
        async notificarProcedimentoInserido() {
            await this.tratarEventoBuscaSimples()
            this.fecharModalProcedimento()
            this.$emit('procedimentoInseridoAtualizado', this.atendimentoId)
        },
        async notificarProcedimentoAtualizado() {
            await this.tratarEventoBuscaSimples()
            this.fecharModalEditarProcedimento()
            this.$emit('procedimentoInseridoAtualizado', this.atendimentoId)
        },
        abrirModalEditarProcedimento(procedimentoSelecionado) {
            this.procedimentoSelecionado = procedimentoSelecionado
            this.modalEditarProcedimento = true
        }
    }
}
</script>

<style scoped lang="stylus">

.container-historico-dente
  display flex
  position relative
  top -40px

.container-foto-dente-selecionado
  border 2px solid #b0b0b0
  border-radius 10px
  overflow clip
  width 50px

.container-informacoes-dente
  margin-left 10px
  width 200px

  span
    font-weight bold
    color var(--theme-primary)

.detalhes-procedimentos-item
  display flex

.historico-dente-selecionado
  position relative
  top -30px

.container-btn-iniciar-procedimento
  display flex
  align-items center
  width 100px

</style>